<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row v-if="!loading">
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn depressed rounded color="green" dark :to="{ name: 'frota.motorista' }">
            <v-icon>mdi-arrow-left</v-icon>
            Voltar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card v-if="!loading" outlined>
      <v-card-text>
        <v-row>
          <v-col cols="2">
            <v-img v-if="isShowFoto" :aspect-ratio="3/4" :src="fotoUrl" />
            <v-img v-else :aspect-ratio="3/4" src="@/assets/default_avatar.png" />
          </v-col>
          <v-col cols="10">
            <v-simple-table class="table-bordered" dense>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td width="75%" colspan="3">
                    <small><b>Nome</b></small>
                    <br />
                    {{ data.pessoa.nome }}
                  </td>
                  <td width="25%" colspan="1">
                    <small><b>CPF</b></small>
                    <br />
                    {{ data.pessoa.cpf_cnpj }}
                  </td>
                </tr>
                <tr>
                  <td width="25%">
                    <small><b>Número CNH</b></small>
                    <br />
                    {{ data.numero_cnh }}
                  </td>
                  <td width="25%">
                    <small><b>Categoria CNH</b></small>
                    <br />
                    {{ data.categoria_cnh.nome }}
                  </td>
                  <td width="25%">
                    <small><b>Expedição CNH</b></small>
                    <br />
                    {{ data.expedicao_cnh | dateBR }}
                  </td>
                  <td width="25%">
                    <small><b>Validade CNH</b></small>
                    <br />
                    {{ data.validade_cnh | dateBR }}
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <small><b>Ativo?</b></small>
                    <br />
                    {{ data.ativo ? 'Sim' : 'Não' }}
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider class="py-3"></v-divider>
    <TableDocumentos />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TableDocumentos from './TableDocumentos.vue';

export default {
  name: 'MotoristaShow',
  components: { TableDocumentos },
  metaInfo: {
    title: 'Informações do Motorista',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Informações do Motorista',
    tab: null,
    loading: false,
  }),
  created() {
    this.loadMotorista();
  },
  methods: {
    ...mapActions('motorista', ['find']),
    loadMotorista() {
      this.loading = true;
      this.find({ id: this.$route.params.id }).finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState('motorista', ['data']),
    isShowFoto() {
      return !!(this.data && this.data.pessoa && this.data.pessoa.foto);
    },
    fotoUrl() {
      return this.isShowFoto ? this.data.pessoa.foto.foto_url : null;
    },
  },
};
</script>

<style lang="scss">
.table-bordered {
  border: thin solid rgba(0, 0, 0, 0.12);

  tr td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }

  tr td:nth-child(1) {
    border-left: none;
  }
}
</style>
